"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addIseeEye = addIseeEye;
exports.addPageStatis = void 0;
exports.getIseeBiz = getIseeBiz;
exports.sendQQ = exports.sendMylog = exports.sendIlog = exports.sendGPO = exports.sendGIO = exports.sendBD = exports.isInitGIO = void 0;

var load = _interopRequireWildcard(require("./load"));

var _tools = require("./tools");

var _config = _interopRequireDefault(require("./config"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var root = {};
var oldUrl = null;

if (typeof window !== 'undefined') {
  root = window;
}

var loaderGIO = false; // GIO是否初始化

var isInitGIO = loaderGIO;
/**
 * 添加页面统计
 */

exports.isInitGIO = isInitGIO;

var addPageStatis = function addPageStatis() {
  var currentURL = root.location.href;
  var isCurrentURL = oldUrl !== currentURL;

  if (isCurrentURL) {
    oldUrl = currentURL; // mylog

    if (typeof root.__mylog === 'undefined') {
      load.js('//static.iyb.tm/web/lib/mylog/2.0/mylog.min.js');
    } else {
      root.__mylog.send();
    } // 推广产品流量太多，禁止加载gio黑名单


    var blacklist = ['/m/short/trial/market'];

    if (blacklist.indexOf(root.location.pathname) < 0) {
      try {
        if (typeof root.gio === 'undefined') {
          // App 原生加载SDK，设置App webview 不采集
          root.webViewRequestSend = false; // eslint-disable-next-line func-names

          root.gio = root.gio || function () {
            (root.gio.q = root.gio.q || []).push(root, document, 'script', 0, 'gio');
          };

          var resource = (0, _tools.getParameterByName)('_resource');

          if ((window.__wxjs_environment === 'miniprogram' || /miniProgram/i.test(navigator.userAgent.toLowerCase())) && resource === 'iyb_weike_lite') {
            // 增加为客栈小程序的gio埋点
            load.js('//assets.giocdn.com/2.0/gio-wxwv.js', function () {
              root.gio('init', 'b191d4a76e67e693', 'wx47189fc9465995a2', {
                platform: 'Minp'
              });
              root.gio('send');
              loaderGIO = true;
            });
          } else {
            load.js('//assets.giocdn.com/2.1/gio.js', function () {
              root.gio('init', 'b191d4a76e67e693');
              root.gio('sendPage');
              loaderGIO = true;
            });
          }
        } else {
          root.gio('send');
        }
      } catch (error) {
        console.error(error);
      }
    } // 腾讯统计配置


    if (typeof root.MtaH5 === 'undefined') {
      root._mtac = {
        senseQuery: 1
      };
      load.js({
        src: '//pingjs.qq.com/h5/stats.js?v2.0.4',
        name: 'MTAH5',
        sid: '500613729',
        cid: '500613730'
      });
    } else {
      root.MtaH5.pgv();
    }
  }
};
/**
 * ilog 发送事件统计 delete date 2019-10-28
 * @param {string} name 统计名字
 */


exports.addPageStatis = addPageStatis;

var sendIlog = function sendIlog() {};
/**
 * 百度 发送事件统计
 * @param {string} name     统计名字
 * @param {string} category 要监控的目标的类型名称
 */


exports.sendIlog = sendIlog;

var sendBD = function sendBD() {};
/**
 * 腾讯 发送事件统计
 * @param {string} name     统计名字
 * @param {object} params   需要参数
 */


exports.sendBD = sendBD;

var sendQQ = function sendQQ() {
  var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var params = arguments.length > 1 ? arguments[1] : undefined;

  if (root.MtaH5) {
    root.MtaH5.clickStat(name, params);
  }
};

exports.sendQQ = sendQQ;
var stackLog = [];
var timer = null;
/**
 * mylog 发送事件统计
 * @param  {string} name     统计名字
 * @param  {object} param    参数
 * @config {string} source   来源
 */

var sendMylog = function sendMylog() {
  var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var param = arguments.length > 1 ? arguments[1] : undefined;

  if (name === '') {
    return false;
  }

  if (root.__mylog) {
    if (param) {
      root.__mylog.send(name, param);
    } else {
      root.__mylog.send(name);
    }
  } else {
    // 保留数据
    stackLog.push({
      name: name,
      param: param
    });

    if (!timer) {
      timer = setInterval(function () {
        if (root.__mylog) {
          stackLog.forEach(function (item) {
            sendMylog(item.name, item.param);
          });
          clearInterval(timer);
        }
      }, 100);
    }
  }
};
/**
 * gop 发送事件统计
 * @param {string}         action     统计名字
 * @param {object, string} params     object 需要参数, string url方式
 * @param {string}         accountId  用户ID
 */


exports.sendMylog = sendMylog;

var sendGPO = function sendGPO() {
  var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var accountId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var url = "https://gpo.iyunbao.com/stat/actionForH5.json?action=".concat(action);

  if (typeof params === 'string') {
    url += "&url=".concat(params);
  }

  if (Object.keys(params).length) {
    url += "&plus=".concat(encodeURI(JSON.stringify(params)));
  }

  if (accountId) {
    url += "&accountId=".concat(accountId);
    var img = new Image();
    img.src = url;
  } else {
    (0, _tools.getAppAccountId)().then(function (id) {
      url += "&accountId=".concat(id);
      var img = new Image();
      img.src = url;
    }).catch(function (err) {
      console.log(err);
    });
  }
};
/**
 * growingio 发送事件统计
 * @param  {string} name     统计名字
 * @param  {object} param    参数
 */


exports.sendGPO = sendGPO;

var sendGIO = function sendGIO() {
  var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var param = arguments.length > 1 ? arguments[1] : undefined;

  if (root.gio) {
    root.gio('track', name, param);
  }
};
/**
 * 添加可回溯（众安千里眼）
 * @param {function}  cb     回调
 */


exports.sendGIO = sendGIO;

function addIseeEye(cb) {
  if (!document.getElementById('iseeEye')) {
    load.js({
      src: _config.default.URL.isee,
      id: 'iseeEye'
    }, cb);
  } else {
    cb && cb();
  }
}
/**
 * 获取回溯码（众安千里眼）
 */


function getIseeBiz() {
  return new Promise(function (resolve) {
    addIseeEye(function () {
      var interval = 200;
      var loaderTime = 0; // 加载多个js

      var bizTime = setInterval(function () {
        if (typeof root.getIseeBiz !== 'undefined') {
          clearInterval(bizTime);
          root.getIseeBiz().then(function (biz) {
            resolve(biz);
          }); // 超过5秒，停止
        } else if (loaderTime > 5000) {
          clearInterval(bizTime);
        }

        loaderTime += interval;
      }, interval);
    });
  });
}